export default __webpack_public_path__ + "static/media/report_analysis.f94ed932.svg";